import { render, staticRenderFns } from "./createTeam.vue?vue&type=template&id=4ff8d412&scoped=true"
import script from "./createTeam.vue?vue&type=script&lang=js"
export * from "./createTeam.vue?vue&type=script&lang=js"
import style0 from "./createTeam.vue?vue&type=style&index=0&id=4ff8d412&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8d412",
  null
  
)

export default component.exports